<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Edit Mammal</template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="9">
              <b-row class="justify-content-md-center">
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('lastname')}"> -->
                  <b-form-group label="Common Name">
                    <b-form-input
                      v-model="commonname"
                      type="text"
                      id="commonname"
                      placeholder="Common Name"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('firstname')">
                        <span style="color:red;">{{validation.firstError('firstname')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('firstname')}"> -->
                  <b-form-group label="Family">
                    <b-form-input v-model="family" type="text" id="family" placeholder="Family"></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('firstname')">
                        <span style="color:red;">{{validation.firstError('firstname')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('middlename')}"> -->
                  <b-form-group label="Latin Name ">
                    <b-form-input
                      v-model="latinname"
                      type="text"
                      id="latinname"
                      placeholder="Latin Name"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('middlename')">
                        <span style="color:red;">{{validation.firstError('middlename')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>

                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('middlename')}"> -->
                  <b-form-group label="Local Name">
                    <b-form-input
                      v-model="localname"
                      type="text"
                      id="localname"
                      placeholder="Local Name"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('middlename')">
                        <span style="color:red;">{{validation.firstError('middlename')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>

                <b-col cols="12" md="12">
                  <!-- <div :class="{error: validation.hasError('lastknown')}"> -->
                  <b-form-group label="Description">
                    <b-form-textarea
                      id="description"
                      v-model="description"
                      placeholder
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                    <!-- <template slot="description" v-if="validation.firstError('lastknown')">
                        <span style="color:red;">{{validation.firstError('lastknown')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>

                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cname')}"> -->
                  <b-form-group label="Mammal Status">
                    <b-form-input v-model="mstatus" id="mstatus" placeholder="Mammal Status"></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cname')">
                        <span style="color:red;">{{validation.firstError('cname')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cemail')}"> -->
                  <b-form-group label="Social Unit">
                    <b-form-input v-model="socialunit" id="socialunit" placeholder="Social Unit"></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cemail')">
                        <span style="color:red;">{{validation.firstError('cemail')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cphone')}"> -->
                  <b-form-group label="Size">
                    <b-form-input v-model="size" id="size" placeholder="Size"></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cphone')">
                        <span style="color:red;">{{validation.firstError('cphone')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cagency')}"> -->
                  <b-form-group label="Behavoiur">
                    <b-form-input v-model="behavoiur" id="behavoiur" placeholder="Behavoiur"></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cagency')">
                        <span style="color:red;">{{validation.firstError('cagency')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cagency')}"> -->
                  <b-form-group label="States">
                    <!-- <b-form-input
                      v-model="distribution"
                      id="distribution"
                      placeholder="Distribution"
                    ></b-form-input> -->
                    <b-form-select
                      multiple
                      :select-size="4"
                      v-model="selected"
                      :options="states"
                      value-field="_id"
                      text-field="name"
                      class="mb-3"
                    >
                    </b-form-select>
                    <!-- <div>Selected: <strong>{{ selected }}</strong></div> -->
                    <!-- <template slot="description" v-if="validation.firstError('cagency')">
                        <span style="color:red;">{{validation.firstError('cagency')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cagency')}"> -->
                  <b-form-group label="Distribution">
                    <b-form-input
                      v-model="distribution"
                      id="distribution"
                      placeholder="Distribution"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cagency')">
                        <span style="color:red;">{{validation.firstError('cagency')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cagency')}"> -->
                  <b-form-group label="Habitat">
                    <b-form-input v-model="habitat" id="habitat" placeholder="Habitat"></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cagency')">
                        <span style="color:red;">{{validation.firstError('cagency')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6"></b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center text-center">
            <b-col cols="8">
              <b-row>
                <b-col
                  md="3"
                  sm="2"
                  xs="2"
                  v-for="(i, index) in photo"
                  :key="i.photo"
                  v-bind:index="index"
                >
                  <b-row>
                    <b-col md="3" sm="3" xs="3" style="padding-top: 17px;">
                      <img
                        class="role active"
                        v-bind:src="baseURL+'/u/'+i.photo"
                        style="width:100px;height:100px;"
                      />
                    </b-col>

                    <b-col md="9">
                      <a>
                        <!-- <b-icon icon="x-square-fill" @click="imgdelete(index)"></b-icon> -->
                        <i class="fa fa-window-close" aria-hidden="true" @click=" imgdelete(i)"></i>
                      </a>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="3" v-for="(item,i) in urls" :key="i">
                  <b-row>
                    <b-col md="3" style="padding-top: 17px;">
                      <img :src="item" class="role active" style="width:100px;height:100px;" />
                    </b-col>
                    <b-col md="9">
                      <!-- <b-icon icon="x-square-fill" @click=" imgremove(i)"></b-icon> -->
                      <i class="fa fa-window-close" aria-hidden="true" @click=" imgremove(i)"></i>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <b-col cols="12" md="6">
              <b-form-group label="Mammal Image">
                <b-form-file
                  v-model="mammalimage"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Select a file"
                  multiple
                  @change="showImage"
                ></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <span style="color:red">{{msg}}</span>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button variant="outline-primary" size="sm" @click.prevent="inputCheck">Submit</b-button>
            </div>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      user: null,
      msg: null,
      mammalId: null,
      commonname: null,
      commonnames: [],
      family: null,
      latinname: null,
      localname: null,
      description: null,
      mammalimage: null,
      newImage: null,
      mstatus: null,
      socialunit: null,
      size: null,
      behavoiur: null,
      habitat: null,
      distribution: null,
      reportimg: null,
      photo: [],
      urls: [],
      states:[],
      selected:[],
      formData: new FormData(),
    };
  },
  mounted() {
    this.getData();
    this.getStates();
  },

  methods: {
    getStates() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/statelist",
        // params: {
        //   id: this.$route.params.id
        // },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.states = response.data.data;
        })
        .catch((e) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/mammal/get",
        params: {
          id: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.report = response.data.data;
          this.commonname = this.report.commonname;
          this.localname = this.report.localname;
          this.latinname = this.report.latinname;
          this.family = this.report.family;
          this.description = this.report.description;
          this.status = this.report.mammalstatus;
          this.socialunit = this.report.socialunit;
          this.behavoiur = this.report.behavoiur;
          this.size = this.report.size;
          this.distribution = this.report.distribution;
          this.habitat = this.report.habitat;
          this.photo = this.report.photos;
          if(this.report.states){
          for(var i=0;i<this.report.states.length;i++)
         
          this.selected.push(this.report.states[i]._id)
          }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },

    inputCheck() {
      this.msg = null;
      //   if (
      //     !this.user.username ||
      //     !this.user.phone ||
      //     !this.user.prefix ||
      //     !this.user.password
      //   )
      // this.msg = "Please Provide required Fields";
      //   else
      this.editMammal();
    },
    editMammal() {
      this.appLoading = true;
      var suspect = {};
      suspect["id"] = this.$route.params.id;
      suspect["commonname"] = this.commonname;
      suspect["family"] = this.family;
      suspect["latinname"] = this.latinname;
      suspect["localname"] = this.localname;
      suspect["description"] = this.description;
      suspect["mammalstatus"] = this.mstatus;
      suspect["socialunit"] = this.socialunit;
      suspect["size"] = this.size;
      suspect["behaviour"] = this.behavoiur;
      suspect["distribution"] = this.distribution;
      suspect["habitat"] = this.habitat;
      suspect["states"] = this.selected;
      axios({
        method: "POST",
        url: "/mammal/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: suspect,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (this.urls.length > 0) {
              this.uploadmammalImage();
            } else this.$router.push("/Mammals/" + this.$route.params.id);
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },

    imgremove(index) {
      this.urls.splice(index, 1);
    },
    imgdelete(index) {
      console.log(index)
      var data = {};
      data["id"] = index;
      // data["position"] = index + 1;
      axios({
        method: "POST",
        url: "/mammal/removephoto",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status == true) {
          // this.msg = "Image Deleted";

          this.getData();
          this.showsnackbar = true;
        }
      });
    },
    showImage(event) {
      var selectedFiles = event.target.files[0];
      //   this.productPictures.append("photos", this.selectedFiles);

      var img;
      img = new Image();
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = () => {
        if (
          selectedFiles.size < 5242880 &&
          img.width <= 500 &&
          img.height <= 500
        ) {
          const urls = URL.createObjectURL(selectedFiles);
          if (this.urls.length < 4 - this.photo.length) {
            this.urls.push(urls);
            this.formData.append("photos", selectedFiles);
          } else {
            this.msg = "Four Images Already Added!";
          }
        } else {
          this.msg = "File size Should be less than 5MB";
          return;
        }
      };
    },
    uploadmammalImage() {
      var vm = this;

      this.appLoading = true;

      this.formData.append("id", this.$route.params.id);
      axios({
        method: "POST",
        url: "/mammal/photomultiple",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.formData,
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          vm.uploadMsg = "Uploading " + percentCompleted + "%";
          // if (percentCompleted == 100) vm.uploadMsg = "";
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.$router.push("/Mammals/" + this.$route.params.id);
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
  },
};
</script>
